define('SageDotCom/DataLayer/Events/SolutionFinder/solutionFinderOptionSelected',[
        "jquery",
        "SageDotCom/DataLayer/Events/eventBase"
    ],
    function ($, EventBase) {
        function SolutionFinderOptionSelectedEvent() {
            EventBase.call(this); // inherit eventBase
            this.name = "button_click"; // overwrite name
        }

        SolutionFinderOptionSelectedEvent.prototype = Object.create(EventBase.prototype);

        SolutionFinderOptionSelectedEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(optionSelected) {
            const eventType = "nova_{OPTION}_selected";

            var whitespaceRegex = /\s+/g;
            var friendlyOption = optionSelected.trim().replace(new RegExp(whitespaceRegex), "_");
            var text = eventType.replace("{OPTION}", friendlyOption);

            var eventData = {
                'event_name': this.getName(),
                'element_text': text
            }
            return eventData;
        }
        return new SolutionFinderOptionSelectedEvent();
    });
